import { apiClient } from "./api";

// Create candidates from resumes alone — no form, no candidate present.
export const bulkResumeService = {
  /**
   * @param {number} jobId
   * @param {File[]} files    PDF, DOCX or TXT. 25 max, 15 MB each.
   * @param {(pct:number)=>void} [onProgress]  0-100, upload only.
   *
   * → { added, duplicates, failed, screening_started, results[], consent_notice }
   *
   * Always resolves 200 when the request itself succeeds, even if some files
   * could not be read: the per-file verdict is in `results`. A batch where three
   * of twenty were scans is a successful upload with three things to look at,
   * and treating it as an error would throw away the seventeen that worked.
   */
  upload: (jobId, files, onProgress) => {
    const form = new FormData();
    for (const f of files) form.append("resumes", f);

    return apiClient.post(`/resumes/bulk/${jobId}`, form, {
      // Content-Type is not set here on purpose — the browser adds it with the
      // multipart boundary. The apiClient instance defaults every request to
      // `application/json`, which would override that and leave the server with
      // a body it cannot split; its request interceptor strips the header when
      // the payload is FormData, which is what makes this work.
      //
      // Parsing is slower than uploading here: every file costs a text
      // extraction and a model call, so the default axios timeout expires on a
      // batch of any size.
      timeout: 5 * 60 * 1000,
      onUploadProgress: (e) => {
        if (!onProgress || !e.total) return;
        onProgress(Math.round((e.loaded * 100) / e.total));
      },
    });
  },
};

export default bulkResumeService;
